/*
 * Two-tone feature icons for the marketing site. Each is drawn on a 32-unit
 * grid: fine ink strokes (currentColor) plus one Pendora-red accent
 * (.fi-accent, a soft tint fill; .fi-red, a solid red detail). Colours come
 * from CSS so the set follows the cream and night themes and the hover state.
 */

const Svg = ({ children }) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 32 32"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

export const FiKey = () => (
  <Svg>
    <circle className="fi-accent" cx="10.5" cy="16" r="6.5" />
    <circle cx="10.5" cy="16" r="2.2" />
    <path d="M17 16h11" />
    <path className="fi-red" d="M23.5 16v4.2M27.5 16v3" />
  </Svg>
);

export const FiExpiry = () => (
  <Svg>
    <circle cx="16" cy="17" r="10" />
    {/* the part of the window already used, in red */}
    <path className="fi-red" d="M16 7a10 10 0 0 1 9.5 13.1" />
    <path d="M16 11.5V17l3.5 2.2" />
    <path d="M13 3.5h6" />
  </Svg>
);

export const FiStamp = () => (
  <Svg>
    <path className="fi-accent" d="M8 4h11.5L25 9.5V28H8Z" />
    <path d="M19.5 4v5.5H25" />
    <path d="M11.5 14h7M11.5 18h10" />
    {/* the buyer's watermark across the page */}
    <path className="fi-red" d="M10.5 25.5 22.5 21" />
  </Svg>
);

export const FiLock = () => (
  <Svg>
    <path d="M10.5 14V10.5a5.5 5.5 0 0 1 11 0V14" />
    <rect className="fi-accent" x="6.5" y="14" width="19" height="14" rx="3.5" />
    <circle className="fi-red-fill" cx="16" cy="20" r="1.8" />
    <path d="M16 21.5v2.5" />
  </Svg>
);

export const FiLanguages = () => (
  <Svg>
    <circle className="fi-accent" cx="13" cy="13" r="9" />
    <path d="M4 13h18M13 4c-2.6 2.6-3.6 5.6-3.6 9s1 6.4 3.6 9M13 4c2.6 2.6 3.6 5.6 3.6 9" />
    {/* a speech bubble: the page talks back in the customer's language */}
    <path className="fi-red" d="M19.5 19.5h8v6h-3l-2.5 2.5v-2.5h-2.5Z" />
  </Svg>
);

export const FiVariants = () => (
  <Svg>
    <path d="M11 8V5.5A1.5 1.5 0 0 1 12.5 4H24a1.5 1.5 0 0 1 1.5 1.5V20" />
    <rect className="fi-accent" x="6.5" y="8" width="15" height="20" rx="2" />
    <path d="M10 14h8M10 18h6" />
    <path className="fi-red" d="M10 23h4.5" />
  </Svg>
);

export const FiEmail = () => (
  <Svg>
    <rect className="fi-accent" x="4" y="8" width="24" height="17" rx="3" />
    <path d="m5 9.5 11 8 11-8" />
    <circle className="fi-red-fill" cx="25.5" cy="8.5" r="3.3" />
  </Svg>
);

export const FiCloud = () => (
  <Svg>
    <path
      className="fi-accent"
      d="M9.5 24h14a5.5 5.5 0 0 0 .6-10.97A8 8 0 0 0 8.6 14.3 5 5 0 0 0 9.5 24Z"
    />
    <path className="fi-red" d="M16 14.5v7M13 19l3 3 3-3" />
  </Svg>
);
